import { normalizeAddress } from '@/shared/lib/utils/format.ts'
import { httpClient } from '@/shared/api/client.ts'
import { NonceRequest, NonceResponse } from '@/domains/auth/api/types'

export function fetchNonce({ walletAddress }: NonceRequest) {
  return httpClient
    .post('member/nonce', {
      json: {
        walletAddress: normalizeAddress(walletAddress),
      },
    })
    .json<NonceResponse>()
}
